export { default } from './index.vue';


// WEBPACK FOOTER //
// ./packages/dof-marquee/index.js